
import "./Quizzes.css"
import img1 from "../../Images/QuizActivityCompletion.png"
import img2 from "../../Images/QuizAddRestriction.png"
import img3 from "../../Images/QuizAppearance.png"
import img4 from "../../Images/QuizCommonModuleSettings.png"
import img5 from "../../Images/QuizContentSave.png"
import img6 from "../../Images/QuizExtraRestrictions.png"
import img7 from "../../Images/QuizFeedbackOptions.png"
import img11 from "../../Images/QuizGradeToPass.png"
import img9 from "../../Images/QuizQuestionBehaviour.png"
import img8 from "../../Images/QuizQuestionlayout.png"
import img10 from "../../Images/QuizSafeExamBrowser.png"
import img12 from "../../Images/QuizTiming.png"
import img13 from "../../Images/UNSMyCourses.png"
import img14 from "../../Images/UNSEditMode.png"
import img15 from "../../Images/UNSAddResource.png"
import img16 from "../../Images/createQuiz.png"
import img17 from "../../Images/QuizDetails.png"
import img18 from "../../Images/QuizFNewQuestion.png"
import img19 from "../../Images/QuizFNewQuestion2.png"
import img20 from "../../Images/QuizFNewQuestion3.png"
import img21 from "../../Images/QuizFNewQuestion4.png"
import img22 from "../../Images/QuizFNewQuestion9.png"
// import { Outlet } from "react-router-dom";


function Quizzes() {
    return (
      <div className="QuizzesCover"> 

            <h1>Quizzes </h1>
            <div className="ContentOutput">
                      <div className="Hyperlinks">
                          <ul>
                              <li><a href="#Section1">Introduction to moodle</a>  </li>
                              <li><a href="#Section2">How to create a Quiz</a>  </li>
                              <li><a href="#Section3">How to add Multiple choice questions to a Quiz</a> </li>
                              <li><a href="#Section4">How to delete a Quiz</a> </li>
                            
                          </ul>

                      </div>
                      <div className="resourceSection">
                      
                      <section id="Section1">

                            <div className="contentWhole">  

                                  <div className="contentHeading">  
                                        <h3>Introduction to Moodle</h3>
                                        </div>
                                              <div className="contentParagraph"> 

                                                  <p> 
                                                      Moodle is the online learning platform used by Unilus. It contains individual spaces for each of your modules, where you can access a variety of information, materials, and activities. 
                                                  </p>    
                                                  <p> 
                                                    Almost all taught modules have a Moodle space.

                                                  </p>    

                                            </div>
                                  <div className="contentImage">  

                                 </div>


                            </div>


                      </section>

                      <section id="Section2">

                      <div className="contentWhole">  

                            <div className="contentHeading">  
                                  <h2>How to create a Quiz</h2>
                                  </div>
                                        <div className="contentParagraph"> 

                                            <p> 
                                              <b> STEP 1 :</b> Navigate to My courses
                                            </p>    
                                            <p> 
                                              {/* Almost all taught modules have a Moodle space. */}

                                            </p>    

                                      </div>
                            <div className="contentImage">  
                                <img src={img13} />

                          </div>
                                        <div className="contentParagraph"> 

                                            <p> 
                                            <b>
                                                STEP 2 : </b>Enable edit mode
                                            </p>    
                                            <p> 
                                              {/* Almost all taught modules have a Moodle space. */}

                                            </p>    

                                      </div>
                            <div className="contentImage">  
                                <img src={img14} />

                          </div>
                                 
                                        <div className="contentParagraph"> 

                                          <p> 
                                              <b>STEP 3 :</b> Click on add activity or resource
                                            </p>    
                                            <p> 
                                              {/* Almost all taught modules have a Moodle space. */}

                                            </p>    

                                      </div>
                            <div className="contentImage">  
                                <img src={img15} />

                          </div>
                                        <div className="contentParagraph"> 

                                          <p> 
                                              <b>STEP 4 :</b>  Navigate to and click on Quiz
                                            </p>   
                                            <p> 
                                              {/* Almost all taught modules have a Moodle space. */}

                                            </p>    

                                      </div>
                            <div className="contentImage">  
                                <img src={img16} />

                          </div>
                                        <div className="contentParagraph"> 

                                          <p> 
                                              <b>STEP 7 :</b>  Fill in the class details as in the illustration
                                            </p>   
                                            <p> 
                                              {/* Almost all taught modules have a Moodle space. */}

                                            </p>    

                                      </div>
                            <div className="contentImage">  
                                <img src={img17} />

                          </div>
                                        <div className="contentParagraph"> 

                                          <p> 
                                              <b>STEP 7 :</b>  Enter timing and date restriction as in illustration
                                            </p>   
                                            <p> 
                                              {/* Almost all taught modules have a Moodle space. */}

                                            </p>    

                                      </div>
                            <div className="contentImage">  
                                <img src={img7} />

                          </div>
                                        <div className="contentParagraph"> 

                                          <p> 
                                              <b>STEP 8 :</b>  Navigate to Grade section (We recommend you leave defaults)
                                            </p>   
                                        

                                      </div>
                            <div className="contentImage">  
                                <img src={img11} />

                          </div>
                                        <div className="contentParagraph"> 

                                          <p> 
                                              <b>STEP 8 :</b>  Navigate to Layout (This is to set how many questions for page; we recommend 10% of the total questions)
                                            </p>   
                                         
                                      </div>
                            <div className="contentImage">  
                                <img src={img8} />

                          </div>
                                        <div className="contentParagraph"> 

                                          <p> 
                                              <b>STEP 8 :</b>  Navigate to Question behavior (We recommend you leave as default)
                                            </p>   
                                            <p> 
                                              

                                            </p>    

                                      </div>
                            <div className="contentImage">  
                                <img src={img9} />

                          </div>
                                        <div className="contentParagraph"> 

                                          <p> 
                                              <b>STEP 8 :</b>  Navigate to review and appearance (we recommend you as defaults)
                                            </p>   
                                            <p> 
                                            

                                            </p>    

                                      </div>
                            <div className="contentImage">  
                                <img src={img8} />

                          </div>
                                        <div className="contentParagraph"> 

                                          <p> 
                                              <b>STEP 8 :</b>  Navigate to extra restrictions (this allows you to add a password to the quiz, its optional)
                                            </p>   
                                            <p> 
                                              

                                            </p>    

                                      </div>
                            <div className="contentImage">  
                                <img src={img6} />

                          </div>
                                        <div className="contentParagraph"> 

                                          <p> 
                                              <b>STEP 8 :</b>  Overall feedback & later common module settings (we recommend you leave as default)
                                            </p>   
                                          

                                      </div>
                            <div className="contentImage">  
                                <img src={img4} />

                          </div>
                                        <div className="contentParagraph"> 

                                          <p> 
                                              <b>STEP 8 :</b>  Navigate to Add restrictions & add respective restrictions
                                            </p>   
                                      

                                      </div>
                            <div className="contentImage">  
                                <img src={img2} />

                          </div>
                                        <div className="contentParagraph"> 

                                          <p> 
                                              <b>STEP 8 :</b>  Navigate to Tags and competences (we recommend you leave as defaults)
                                            </p>   
                                          
                                      </div>
                            <div className="contentImage">  
                                <img src={img2} />

                          </div>
                                        <div className="contentParagraph"> 

                                          <p> 
                                              <b>STEP 8 :</b>  Enable content modification send and the save
                                            </p>   
                                          
                                      </div>
                            <div className="contentImage">  
                                <img src={img5} />

                          </div>


                      </div>


                      </section>
                      <section id="Section3">

<div className="contentWhole">  

      <div className="contentHeading">  
            <h2>How to enter Multiple choice questions</h2>
            </div>
            <div className="contentParagraph"> 

<p> 
  <b> STEP 1 :</b> Navigate to respective then to ADD QUESTION
</p>    
<p> 
  {/* Almost all taught modules have a Moodle space. */}

</p>    

</div>
<div className="contentImage">  
<img src={img13} />

</div>
<div className="contentParagraph"> 

<p> 
<b>
    STEP 2 : </b>Select Question type (Multiple choice)
</p>    
<p> 
  {/* Almost all taught modules have a Moodle space. */}

</p>    

</div>
<div className="contentImage">  
<img src={img22} />

</div>

<div className="contentParagraph"> 

<p> 
  <b>STEP 3 :</b> Type the question under QUESTION NAME and Description 
</p>    
<p> 
  {/* Almost all taught modules have a Moodle space. */}

</p>    

</div>
<div className="contentImage">  
<img src={img18} />

</div>
<div className="contentParagraph"> 

<p> 
  <b>STEP 4 :</b>  Type the options [Enter 100% on correct option and NONE on the other options]
</p>   
<p> 
  {/* Almost all taught modules have a Moodle space. */}

</p>    

</div>
<div className="contentImage">  
<img src={img19} />

</div>
                
</div>


</section>
<section id="Section4">

<div className="contentWhole">  

      <div className="contentHeading">  
            <h3>How to delete a Quiz</h3>
            </div>
                  <div className="contentParagraph"> 

                      <p> 
                          Moodle is the online learning platform used by Unilus. It contains individual spaces for each of your modules, where you can access a variety of information, materials, and activities. 
                      </p>    
                      <p> 
                        Almost all taught modules have a Moodle space.

                      </p>    

                </div>

                <div className="contentParagraph"> 

                      <p> 
                            <b>STEP 1 :</b>  Navigate to the respective class(Activity) 
                            </p>   
                            <p> 
                            {/* Almost all taught modules have a Moodle space. */}

                      </p>    

                </div>
                <div className="contentImage">  
             
                      <img src={img8} />

                </div>

                <div className="contentParagraph"> 

                      <p> 
                            <b>STEP 2 :</b>  Click on the three stacked dots icon then Delete 
                            </p>   
                            <p> 
                            {/* Almost all taught modules have a Moodle space. */}

                      </p>    

                </div>
                <div className="contentImage">  
             
                      <img src={img12} />

                </div>
                                              


</div>


</section>



                      </div>
                </div>
     
      </div>
    );
  }
  
  export default Quizzes;
  